const DEFAULT_CURRENCY = 'USD'
const DEFAULT_LANGUAGE = 'en'
const initialState = {
  currency: DEFAULT_CURRENCY,
  currencyLoaded: false,
  language: DEFAULT_LANGUAGE,
  languageLoaded: false,
}

export default initialState
